export enum ErrorCodes1C {
    unsuccessfulDeviceReservation = 4
}